import axios from '../config/axios';
import StorageService from '../services/StorageService';

class AuditHttpService {
    static async getAudits(page = 1, limit = 20) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/audit`,
                {
                    params: {
                        page,
                        limit
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${StorageService.getAuth()?.token ?? ''}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default AuditHttpService;
